
export default {
  props: {
    module: Object,
    group: Object,
  },

  data() {
    return {
      isReady: false,
      template: {},
      valid: false,
    }
  },

  watch: {
    group: {
      handler(val) {
        if (val) {
          let atLeastOne = false
          for (const entity in val) {
            if (val[entity]) atLeastOne = true
          }
          this.$emit('valid', atLeastOne)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    _group: {
      set(value) {
        this.$emit('update:group', value)
      },

      get() {
        return this.group
      },
    },
  },

  mounted() {
    const id = () => Math.random().toString(36).substring(2, 8)
    if (!this.group) this._group = {}
    this.module.content.inputsGrid?.forEach((item) => {
      const image = item.content.image[0]
      this.template[(image.alt ? image.alt : image.filename) + ` (${id()})`] = {
        label: image.alt,
        filename: image.filename,
        module: 'select-image',
        width: item.w,
        height: item.h,
        x: item.x,
        y: item.y,
      }
    })
    // this.module.content.images.forEach((image) => {
    //   this.template[image.alt ? image.alt : image.filename] = {
    //     label: image.alt,
    //     filename: image.filename,
    //     module: 'select-image',
    //   }
    // })
    this.isReady = true
  },
}
